import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_015.jpg';
page.images = [
  {
    imageId: 'page015_zoom0',
    rectangle: {
      x: 56,
      y: 1330,
      width: 1575,
      height: 1122,
    },
    imageSrc: 'images/page015/015 2.jpg',
  },
  {
    imageId: 'page015_zoom1',
    rectangle: {
      x: 128,
      y: 293,
      width: 1647,
      height: 855,
    },
    imageSrc: 'images/page015/015 1.jpg',
  },
];
export default page;
